import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

export const fetchEntityOptions = createAsyncThunk(
  'options/fetchEntityOptions',
  async ({ entityName, fieldName, optionsFunc, optionsFuncInput, cacheKey }, { dispatch }) => {
    const options = await optionsFunc(optionsFuncInput);
    dispatch(setEntityOptions({ 
      fullyQualifiedFieldName: `${entityName}.${fieldName}`,
      cacheKey,
      options 
    }));
    return options;
  }
);

const optionsSlice = createSlice({
  name: 'options',
  initialState: {
    entities: {},
    loading: {},
    error: {}
  },
  reducers: {
    setEntityOptions: (state, action) => {
      const { fullyQualifiedFieldName, cacheKey, options } = action.payload;
      if (!state.entities[fullyQualifiedFieldName]) {
        state.entities[fullyQualifiedFieldName] = {};
      }
      state.entities[fullyQualifiedFieldName][cacheKey] = options;
      state.loading[fullyQualifiedFieldName] = false;
      delete state.error[fullyQualifiedFieldName];
    },
    clearEntityOptions: (state, action) => {
      const { fullyQualifiedFieldName, cacheKey } = action.payload;
      delete state.entities?.[fullyQualifiedFieldName]?.[cacheKey];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchEntityOptions.pending, (state, action) => {
        const { entityName, fieldName } = action.meta.arg;
        const key = `${entityName}.${fieldName}`;
        state.loading[key] = true;
      })
      .addCase(fetchEntityOptions.rejected, (state, action) => {
        const { entityName, fieldName } = action.meta.arg;
        const key = `${entityName}.${fieldName}`;
        state.loading[key] = false;
        state.error[key] = action.error.message;
      });
  }
});

export const selectEntityOptions = (state, entityName, cacheKey) => 
  state.options.entities?.[entityName]?.[cacheKey];

export const selectOptionsLoading = (state, entityName, fieldName) => 
  state.options.loading?.[`${entityName}.${fieldName}`] ?? false;

export const { setEntityOptions, clearEntityOptions } = optionsSlice.actions;
export default optionsSlice.reducer;
